// Built-in starter profiles: read-only recipes offered under "Start from…" and as one tap
// "Add to mine" (a copy is an ordinary create). They are validated by the same schema in tests.
import { THEME_SPEC_V, type ThemeSpec } from '@/kinds/themeprofile/schema'

export interface Starter {
  id: string
  name: string
  emoji: string
  blurb: string
  theme: ThemeSpec
}

export const PUMPKIN = '#ff7a1a'
export const SLIME = '#9bff3c'

export const STARTERS: Starter[] = [
  {
    id: 'halloween-deluxe',
    name: 'Halloween deluxe',
    emoji: '🎃',
    blurb: 'Halloween’s surfaces, a pumpkin accent, slime-green highlights and drifting fog',
    theme: {
      v: THEME_SPEC_V,
      base: 'halloween',
      scheme: 'auto',
      accent: { colour: PUMPKIN, highlight: SLIME },
      background: { kind: 'backdrop', id: 'haunt' },
      icons: { close: 'pumpkin' },
      modes: {
        light: {
          surfaces: {
            background: '#fbf3e8',
            raised: '#fffaf2',
            hairline: '#e6d3bb',
            text: '#2a1608',
            muted: '#6a4a2c',
            faint: '#8f6f50',
          },
          accent: { colour: '#c2410c', highlight: '#3f7d0a' },
          background: { kind: 'solid' },
        },
        // black keeps its true black; the pumpkin and slime are asked for by name
        black: {
          accent: { colour: PUMPKIN, highlight: SLIME },
          background: { kind: 'backdrop', id: 'haunt' },
        },
      },
      motion: 'full',
    },
  },
  {
    id: 'ink',
    name: 'Ink',
    emoji: '🖤',
    blurb: 'True black with hairlines and one cool accent',
    theme: { v: THEME_SPEC_V, scheme: 'black', modes: { black: { accent: { colour: '#7dd3fc' } } } },
  },
]

export const starterById = (id: string): Starter | undefined => STARTERS.find((s) => s.id === id)
